import { computed, onMounted, onScopeDispose } from 'vue';
import { useInitPage } from '~/composables/use-init-page';
import { createWindowScrollTracker } from '~/utils/window-scroll';
import { scrollToElement, scrollToTop, scrollToBottom } from '~/utils/scroll';

// Состояние принадлежит экземпляру Nuxt: SSR-запросы не разделяют реактивные данные.
const trackers = new WeakMap<object, ReturnType<typeof createWindowScrollTracker>>();

export function useScroll({ threshold = 80, debounceTime = 500 } = {}) {
  const app = useNuxtApp();
  const page = useInitPage();
  let tracker = trackers.get(app);
  if (!tracker) {
    tracker = createWindowScrollTracker();
    trackers.set(app, tracker);
  }
  const { position, cookieHeight, percentage } = tracker;
  const { start, stop, direction } = tracker.consumer(debounceTime);

  onMounted(() => {
    if (import.meta.client) start();
  });
  onScopeDispose(stop);

  return {
    windowScrollY: position,
    isScrolledDown: computed(() => {
      if (!import.meta.client) return false;
      return position.value > threshold + (page.isMobile.value ? cookieHeight.value : 0);
    }),
    isScrollingDown: computed(() => direction.value === 'down'),
    isScrollingUp: computed(() => direction.value === 'up'),
    scrollPercentage: percentage,
    scrollDirection: direction,
    // Совместимость для потребителей, которым нужны и состояние, и прокрутка.
    scrollToElement,
    scrollToTop,
    scrollToBottom,
  };
}
